import { useAvailableTestsQuery } from '@innovamat/glow-api-client';
import type { Test } from '../modules/available-tests/test';

type UseAvailableTests = {
  accessAllowedNow: boolean;
  availableTests: Test[];
  refetchAvailableTests: () => void;
};

type Props = {
  userId: string;
};

function useAvailableTests({ userId }: Props): UseAvailableTests {
  const { data, refetch: refetchAvailableTests } = useAvailableTestsQuery(
    { userId: userId },
    {
      enabled: !!userId,
    }
  );

  const accessAllowedNow = Boolean(data?.availableTests?.accessAllowedNow);
  const availableTests =
    (data?.availableTests?.availableTests?.filter(Boolean) as Test[]) || [];

  return {
    accessAllowedNow,
    availableTests,
    refetchAvailableTests,
  };
}

export { useAvailableTests };
